export function getInitialsFromFirstLast(
  firstName?: string | null,
  lastName?: string | null,
  fallback = 'U',
): string {
  const firstInitial = firstName?.trim().charAt(0) ?? '';
  const lastInitial = lastName?.trim().charAt(0) ?? '';
  const initials = `${firstInitial}${lastInitial}`.toUpperCase();

  return initials || fallback;
}

export function getInitialsFromFullName(name?: string | null, fallback = 'U'): string {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.charAt(0) ?? '' : '';

  return `${first}${last}`.toUpperCase() || fallback;
}

export function getInitialsFromWords(value?: string | null, fallback = 'U'): string {
  const parts = value?.trim().split(/\s+/).filter(Boolean) ?? [];
  const initials = `${parts[0]?.charAt(0) ?? ''}${parts[1]?.charAt(0) ?? ''}`.toUpperCase();

  return initials || fallback;
}

export function getPersonInitials(
  person: { firstName?: string | null; lastName?: string | null; name?: string | null },
  fallback = 'U',
): string {
  const fromNames = getInitialsFromFirstLast(person.firstName, person.lastName, '');
  if (fromNames) {
    return fromNames;
  }

  return getInitialsFromFullName(person.name, fallback);
}
